import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {searchAuthUsers} from "../services/UserService";
import {useLogout} from "./useLogout";

// User search by login / name / email (GET /api/v3/auth/users?search=&businessUnitCode=, TMMFX-2171).
// businessUnitCode is optional (omitted → unscoped). Returns {users, isLoading, isError}.
export function useAuthUserSearch(search, businessUnitCode, enabled = true) {
    const logout = useLogout();
    const {data, isLoading, isError, error} = useQuery({
        queryKey: ["authUserSearch", search, businessUnitCode ?? null],
        queryFn: () => searchAuthUsers(search, businessUnitCode),
        enabled: enabled && !!search && search.trim().length > 0,
        retry: false,
    });

    useEffect(() => {
        if (isError && error?.response?.status === 401) {
            logout();
        }
    }, [isError, error]);

    return {users: data ?? [], isLoading, isError};
}
